import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';

export const WidgetHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${sizes.small};
`;

export const WidgetHeaderAdditional = styled.div<{ concise?: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  gap: ${({ concise }) => concise ? sizes.xSmall : sizes.small};
`;

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const BorderedContent = styled.div`
  padding: ${sizes.small};
  background: ${colors.white};
  border: 1px solid ${colors.gray3};
  border-radius: 8px;
  width: 100%;
`;

export const NoGroupSelected = styled(StandardTypography)<{ center?: boolean }>`
  display: block;
  text-align: ${({ center }) => center ? 'center' : 'initial'};
`;

export const WidgetHeaderLeft = styled.div`
  margin-right: auto;
`;
